<template>
  <div class="datepicker-container">
    <el-checkbox
      class="datepicker-container__item"
      :value="isTimeEnabled"
      @change="toggleTime"
    >
      <!-- show picker toggler label -->
      <slot name="toggle">Enable</slot>
    </el-checkbox>
    <el-date-picker
      v-model="timeLine"
      class="datepicker-container__item picker"
      :class="{ picker_hidden: !isTimeEnabled }"
      format="yyyy-MM-dd HH:mm"
      type="datetime"
    />
    <span class="timezone" :class="{ timezone_hidden: !isTimeEnabled }">
      in {{ timezone }}
    </span>
  </div>
</template>

<script>
import { formatTime, parseTime } from "@/utils/time.js";

const min = 60 * 1000;
const hour = 3600 * 1000;
const nowAccurateByMins = Math.floor(Date.now() / min) * min;
const defaultTime = new Date(nowAccurateByMins + hour);

// @group Socials
// Set sharing time
export default {
  name: "SharingTimePicker",
  model: {
    prop: "time",
    event: "updateTime"
  },
  props: {
    /** date & time */
    time: {
      type: Date,
      default: null
    },
    /** picker timezone */
    timezone: {
      type: String,
      default: "UTC"
    }
  },
  data() {
    return {
      /** saved time to store when picker is disabled */
      savedTime: defaultTime
    };
  },
  computed: {
    // @vuese
    // Time converted to passed timezone
    timeLine: {
      get() {
        const time = formatTime(
          this.time / 1000,
          "YYYY-MM-DD HH:mm",
          this.timezone
        );
        return time;
      },
      set(val) {
        const time = parseTime(val.toString(), this.timezone);
        this.$emit("updateTime", time);
      }
    },
    // @vuese
    // Is picker enabled
    isTimeEnabled() {
      return this.time !== null;
    }
  },
  methods: {
    // @vuese
    // Enable/disable picker
    toggleTime() {
      if (this.isTimeEnabled) {
        this.savedTime = this.time;
        this.$emit("updateTime", null);
      } else {
        this.$emit("updateTime", this.savedTime);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.datepicker-container {
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  &__item {
    &:not(:last-child) {
      margin-right: 1em;
    }
  }

  @media screen and (max-width: 400px) {
    flex-direction: column;
  }
}

.picker {
  max-width: 200px;
  transition: max-width 0.5s ease-out 0s, opacity 0.25s linear;

  &_hidden {
    max-width: 0;
    opacity: 0;
  }
}

.timezone {
  font-style: italic;

  &_hidden {
    display: none;
  }
}
</style>
